
























































































































import { Mixins, Component } from 'vue-property-decorator';
import { AxPage } from '@/mixins';

import * as I from '@/interfaces';
import * as U from '@/utils';
import * as E from '@/enums';

import AxAPI from '@/api';

type Group = I.AxZone;
type Item = I.Holiday & { subText?: string };

type GroupListPanel = I.AxGroupListPanel<Group, Item>;
type PageInfo = I.HolidayPageInfo;

type DataItem = U.DataItem<unknown, State>;
type DataStore = U.DataStore<unknown, never>;

class State {
  code: number;
  name: string;
  month: number;
  dayOrWeekOrder: number;
  holidayType: E.EHolidayType;
  week: E.EWeek;
  untilYear: number;
  zoneCode: number;
  zoneName: string;
  itemList: string[];
  itemStatus: E.ItemStatus;

  constructor() {
    this.code = '' as never;
    this.name = '' as never;
    this.month = '' as never;
    this.dayOrWeekOrder = '' as never;
    this.holidayType = '' as never;
    this.week = '' as never;
    this.untilYear = '' as never;
    this.zoneCode = '' as never;
    this.zoneName = '' as never;
    this.itemList = [];
    this.itemStatus = E.ItemStatus.None;
  }
}

abstract class BaseClass extends Mixins(AxPage) {
  API!: AxAPI;
  panel!: GroupListPanel;
  pageInfo!: PageInfo;
  dataItem!: DataItem;
}

interface BaseInterface extends BaseClass {}

@Component
class ApiHandler extends BaseClass {
  async getPageInfo() {
    const result = await await this.API.call.holiday.get();
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }

  async updateItem(item: I.HolidayUpdateReq) {
    const result = await this.API.call.holiday.holidayUpdate(item);
    if (result instanceof Error) {
      await this.handleError(result);
      return false;
    } else {
      return result.data;
    }
  }
}

@Component
class DataItemHandler extends BaseClass {
  dataItems: DataItem[] = [
    {
      name: '휴일',
      store: {} as DataStore,
      search: '',
      description: [],
      state: new State()
    }
  ];

  get dataItem() {
    return this.dataItems[0];
  }
}

@Component
class GroupPanelHandler extends BaseClass {
  onListGroupChanged(group?: Group) {
    if (!this.pageInfo || !group) return;

    if (this.panel.items) {
      const listHoliday = (this.pageInfo.listHoliday.filter(
        x => x.zoneCode === this.panel.group
      ) as unknown) as (I.Holiday & { subText: string })[];

      this.panel.items = listHoliday.map(x => {
        if (x.holidayType === E.EHolidayType.SOLAR) {
          x.subText = `(S) ${x.month}. ${x.dayOrWeekOrder}`;
        } else if (x.holidayType === E.EHolidayType.LUNAR) {
          x.subText = `(L) ${x.month}. ${x.dayOrWeekOrder}`;
        } else if (x.holidayType === E.EHolidayType.WEEKS) {
          x.subText = `(W) ${x.month}. ${x.dayOrWeekOrder}. ${E.EWeek[x.week]}`;
        }
        return x;
      });
    }
  }

  onListItemChanged(item?: Item) {
    if (item) {
      const zoneName = this.getZoneList().find(x => x.code === item.zoneCode)?.name || '-';
      this.dataItem.state.itemStatus = E.ItemStatus.Update;
      this.dataItem.state.zoneCode = item.zoneCode;
      this.dataItem.state.zoneName = zoneName;
      this.dataItem.state.code = item.code;
      this.dataItem.state.name = item.name;
      this.dataItem.state.holidayType = item.holidayType;
      this.dataItem.state.dayOrWeekOrder = item.dayOrWeekOrder;
      this.dataItem.state.week = item.week;
      console.log('week', this.dataItem.state.week);
      this.dataItem.state.month = item.month;
      this.dataItem.state.untilYear = item.untilYear;
    } else {
      this.dataItem.state = new State();
    }
  }

  onListAddClicked(group: Group) {
    this.dataItem.state = new State();
    this.dataItem.state.code = 0;
    this.dataItem.state.week = 0;
    this.dataItem.state.zoneCode = group.code;
    this.dataItem.state.zoneName = group.name;
    this.dataItem.state.itemStatus = E.ItemStatus.New;
  }
}

@Component
class BaseData extends Mixins(AxPage) implements BaseInterface {
  dataItem!: DataItem;

  panel: GroupListPanel = {
    groups: [],
    items: [],
    group: -1,
    item: -1
  };

  listHolidayType: HolidayType[] = [
    { eType: E.EHolidayType.SOLAR, name: '양력' },
    { eType: E.EHolidayType.LUNAR, name: '음력' },
    { eType: E.EHolidayType.WEEKS, name: '주간' }
  ];

  pageInfo = {} as PageInfo;

  get listHolidayNames(): string[] {
    return this.listHolidayType.map(x => x.name);
  }
}

interface HolidayType {
  eType: E.EHolidayType;
  name: string;
}

const Handlers = Mixins(ApiHandler, DataItemHandler, GroupPanelHandler);

@Component
export default class Holiday extends Mixins(BaseData, Handlers) {
  async prepare() {
    const pageInfo = await this.getPageInfo();

    if (pageInfo) {
      this.pageInfo = pageInfo;
      this.panel.groups = this.getZoneList();
    }
  }

  async onSaveClicked() {
    const { itemStatus } = this.dataItem.state;
    if (itemStatus === E.ItemStatus.None) return;

    const updateFlag =
      itemStatus === E.ItemStatus.New ? E.EUpdateFlag.Insert : E.EUpdateFlag.Update;

    const {
      code,
      name,
      month,
      dayOrWeekOrder,
      holidayType,
      week,
      untilYear,
      zoneCode
    } = this.dataItem.state;

    const yearVal = Number.parseInt((untilYear as unknown) as string);
    const dayOrWeekVal = Number.parseInt((dayOrWeekOrder as unknown) as string);
    const monthVal = Number.parseInt((month as unknown) as string);

    if (name.length === 0) {
      await this.showErrorModal('오류', '이름을 입력하세요');
      return;
    } else if (!holidayType) {
      await this.showErrorModal('오류', '올바른 날짜 형식을 선택하세요');
      return;
    } else if (Number.isNaN(yearVal) || yearVal < 2000 || yearVal > 9999) {
      await this.showErrorModal('오류', '올바른 종료년도를 입력하세요');
      return;
    } else if (Number.isNaN(dayOrWeekVal) || dayOrWeekVal < 1 || dayOrWeekVal > 31) {
      await this.showErrorModal('오류', '올바른 일자를 입력하세요');
      return;
    } else if (Number.isNaN(monthVal) || monthVal < 1 || monthVal > 12) {
      await this.showErrorModal('오류', '올바른 월을 입력하세요');
      return;
    }

    const title = '확인';
    const message =
      itemStatus === E.ItemStatus.New
        ? '입력한 아이템을 추가할까요?'
        : '선택한 아이템을 수정할까요?';
    const buttons = ['네', '아니오'];

    const confirm = await this.showConfirmModal(title, message, buttons);
    if (confirm !== 0) return;

    this.setLoading(true);
    const result = await this.updateItem({
      code,
      name,
      month,
      dayOrWeekOrder,
      holidayType,
      week,
      untilYear,
      zoneCode,
      updateFlag
    });

    this.setLoading(false);
    if (!result) return;

    this.onUpdated(result, updateFlag);
  }

  async onClearClicked() {
    const confirm = await this.showConfirmModal('확인', '입력중인 내용을 취소할까요?', [
      '네',
      '아니오'
    ]);

    if (confirm === 0) {
      this.dataItem.state = new State();
    }
  }

  async onDeleteClicked() {
    const {
      code,
      name,
      month,
      dayOrWeekOrder,
      holidayType,
      week,
      untilYear,
      zoneCode,
      itemStatus
    } = this.dataItem.state;

    if (itemStatus === E.ItemStatus.None) return;

    const updateFlag = E.EUpdateFlag.Delete;

    const confirm = await this.showConfirmModal('확인', '선택된 아이템을 삭제할까요?', [
      '네',
      '아니오'
    ]);
    if (confirm !== 0) return;

    this.setLoading(true);
    const result = await this.updateItem({
      code,
      name,
      month,
      dayOrWeekOrder,
      holidayType,
      week,
      untilYear,
      zoneCode,
      updateFlag
    });

    this.setLoading(false);
    if (!result) return;
    this.onUpdated(result, E.EUpdateFlag.Delete);
  }

  async onUpdated(result: Item, updateFlag: E.EUpdateFlag) {
    if (!this.pageInfo) return;
    const prevGroup = this.panel.group;

    this.panel.groups = [];
    this.panel.items = [];

    await this.prepare();

    this.panel.group = prevGroup;
    await this.$nextTick();

    if (updateFlag !== E.EUpdateFlag.Delete) {
      this.panel.item = this.panel.items.findIndex(x => x.code === result.code);
    }

    if (updateFlag === E.EUpdateFlag.Insert) {
      this.dataItem.state.itemStatus = E.ItemStatus.Update;
      await this.showErrorModal('알림', '추가되었습니다');
    } else if (updateFlag === E.EUpdateFlag.Update) {
      await this.showErrorModal('알림', '수정되었습니다');
    } else if (updateFlag === E.EUpdateFlag.Delete) {
      this.dataItem.state = new State();
      this.panel.item = -1;
      await this.showErrorModal('알림', '삭제되었습니다');
    }
  }

  get weekItems() {
    return ['일', '월', '화', '수', '목', '금', '토'].map((x, idx) => {
      return {
        code: idx,
        name: x
      };
    });
  }
}
